{
  "title": "Holy Aura",
  "source": "Player's Handbook",
  "levelAndSchool": "8th-level abjuration",
  "level": 8,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S, M (a tiny reliquary worth at least 1,000 gp containing a sacred relic, such as a scrap of cloth from a saint’s robe or a piece of parchment from a religious text)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "Divine light washes out from you and coalesces in a soft radiance in a 30-foot radius around you. Creatures of your choice in that radius when you cast this spell shed dim light in a 5-foot radius and have advantage on all saving throws, and other creatures have disadvantage on attack rolls against them until the spell ends. In addition, when a fiend or an undead hits an affected creature with a melee attack, the aura flashes with brilliant light. The attacker must succeed on a Constitution saving throw or be blinded until the spell ends."
  ],
  "spellLists": ["cleric"]
}
